export enum CustomisableCategoryType {
  QUANTITY = 'quantity',
  RADIO = 'radio',
  CHECKBOX = 'checkbox',
  SUBSTITUTABLE = 'substitutable',
}
